<template>
  <div class="nice-value nice-component">
    <NiceComponentHeader :title="title" />
    <slot class="nice-value-value">{{ value }}</slot>
  </div>
</template>

<script setup>
import { defineProps } from "vue";

defineProps({
  title: String,
  value: String,
  isInline: Boolean,
});
</script>

<style lang="scss" scoped>
.nice-value {
}
</style>
